/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable camelcase */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { getBoxVoipmonActivity } from '../../../../actions/EpikBoxes';
import Spinner from '../../../Spinner/Spinner';
import './Cdr.css';
import { ReactComponent as AnalyticsIcon } from '../../../../Res/CDR/datagram_1.svg';

const callContextLookup = {
  public: 'inbound',
  default: 'outbound',
  enhancedroute: 'outbound',
  tdm: 'outbound' 
}

const Cdr = ({ cdr, index }) => {
  const dispatch = useDispatch();
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const user = useSelector(state => state.AppState.user);
  const [isLoading, setIsLoading] = useState(false);

  const [activeTooltipLogsId, setActiveTooltipLogsId] = useState(null);


  const token = localStorage.getItem('jwtToken') || null;

  const {
    effective_caller_id_number,
    caller_id_number,
    destination_number,
    context,
    start_stamp,
    end_stamp,
    duration,
    rtp_audio_in_mos,
    sip_h_X_Epik_Call_Id,
  } = cdr;

  let destinationNumber = destination_number;
  let callerNumber = effective_caller_id_number;
  if (context === 'public') {
    destinationNumber = sip_h_X_Epik_Call_Id;
    callerNumber = caller_id_number;
  }

  const changeGMT7 = date => {
    return new Date(
      date.getTime() - 7 * 60 * 60 * 1000, // Convert 7 hours to milliseconds
    );
  };

  // Get the current date
  const currentDate = new Date(start_stamp);

  // Adjust the date for GMT-7
  const isoDateStringStartDisplay = moment(changeGMT7(currentDate))
    .subtract(1, 'minutes')
    .format('YYYY-MM-DDTH:mm');

  // Get the current date
  const endDate = new Date(end_stamp);
  // Adjust the date for GMT-7
  const isoDateStringEnd = moment(changeGMT7(endDate))
    .add(1, 'minutes')
    .format('YYYY-MM-DDTH:mm:ss');

  const onRowClick = async e => {
    setIsLoading(true);
    const { calldatefrom, calldateto, callerid, calledid } = e.currentTarget.dataset;
    const { _id } = boxDetails;
    const payload = {
      callDateFrom: calldatefrom || '',
      callDateTo: calldateto || '',
      callerID: callerid || '',
      calledID: calledid || '',
    };
    await dispatch(getBoxVoipmonActivity(token, _id, payload));
    setIsLoading(false);
  };

  const strPadLeft = (string, pad, length) => {
    return (new Array(length + 1).join(pad) + string).slice(-length);
  };

  const time = duration;
  const minutes = Math.floor(time / 60);
  const seconds = time - minutes * 60;

  const callDuration = `${strPadLeft(minutes, '0', 2)}:${strPadLeft(seconds, '0', 2)}`;

  const permissions = user?.role !== 'user' && user?.role !== 'admin';

  const handleMouseEnter = (id, type) => {
    if (type === 'cdr-logs') {
      setActiveTooltipLogsId(id);
    } 
  };

  const handleMouseLeave = (type) => {
    if (type === 'cdr-logs') {
      setActiveTooltipLogsId(null);
    }
  };

  const callContext = context.toLowerCase();
  const hasVoipMonLog = effective_caller_id_number || caller_id_number  || destinationNumber;

  return (isLoading ? (
    <Spinner />
  ) : (
    <>
      <tr>
        {/* <td>1</td> */}
        <td>{callerNumber || '-'}</td>
        <td>{destinationNumber || '-'}</td>
        <td>{context && callContextLookup[callContext] || ''}</td>
        <td>{isoDateStringStartDisplay.split('T')[0]}</td>
        <td>{isoDateStringStartDisplay.split('T')[1]}</td>
        <td>{callDuration}</td>
        <td>{rtp_audio_in_mos || '-'}</td>
        {permissions && hasVoipMonLog && (
          <td className='d-flex'>
            <AnalyticsIcon
              width={20}
              height={20}
              onClick={onRowClick}
              data-calldatefrom={isoDateStringStartDisplay}
              data-calldateto={isoDateStringEnd}
              data-callerid={effective_caller_id_number || caller_id_number || ''}
              data-calledid={destinationNumber || ''}
              className='cursor-pointer analytics-icon mr-2'
              id={`cdr-logs-${index}`}
              onMouseEnter={() => handleMouseEnter(index, 'cdr-logs')}
              onMouseLeave={() => handleMouseLeave('cdr-logs')}
            />
          </td>
        )}
      </tr>
    </>
  ));
};

export default Cdr;
